import { rem } from 'polished'
import styled from 'styled-components'
import theme from 'styles/theme'
import { Body14, Title26 } from 'components/Typography'

export const Wrapper = styled.div`
  margin: 0;
  padding: 0 40px;
  text-align: center;
  flex: 1;
  display: flex;
`

export const Item = styled.li`
  display: block;
  margin: 45px 0 0;
  flex: 1;

  ${theme.mediaQueries.large} {
    margin: 0;
  }

  &:first-child {
    margin-top: 0;
  }
`

export const Counter = styled(Title26)`
  align-items: center;
  background: ${theme.colors.sagelight};
  border-radius: 100%;
  display: flex;
  font-size: ${rem(26)};
  height: 64px;
  justify-content: center;
  letter-spacing: -1.2px;
  margin: 0 auto 20px;
  padding-top: 4px;
  width: 64px;
`

export const ItemHeadline = styled(Title26)`
  line-height: 36px;
  margin: 0 auto 10px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const Desc = styled(Body14)`
  color: ${theme.colors.sagemedium};
  line-height: 20px;
  margin: 0 auto;

  br {
    ${theme.mediaQueries.mobile} {
      display: none;
    }
  }
`
